// ==============================|| OVERRIDES - DRAWER ||============================== //

export default function Drawer(theme) {
  return {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderLeft: 'none',
          boxShadow: theme.customShadows?.z1 || 'none',
          backgroundColor: theme.palette.background.default,
        }
      }
    }
  };
}
